<template>
  <div class="ecard-page">
    <!-- 青蓝标题栏：X关闭 + 居中标题 -->
    <div class="top-bar">
      <div class="close-btn" @click="goBack">
        <svg viewBox="0 0 24 24" class="close-icon">
          <path d="M6 6 L18 18 M18 6 L6 18" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="top-title">领取电子社保卡</div>
    </div>

    <!-- 蓝天白云+红色徽章：设计稿成品图 -->
    <div class="sky">
      <img src="@/assets/icons/ecard-sky.png" class="sky-img" alt="社会保障卡" />
    </div>

    <!-- 白色信息区 -->
    <div class="info-area">
      <!-- 参保人姓名 -->
      <div class="field">
        <div class="field-label">参保人姓名</div>
        <div class="field-value">**杰</div>
      </div>

      <!-- 社会保障号码 -->
      <div class="field field-gap">
        <div class="field-label">社会保障号码</div>
        <div class="field-value">**************5619</div>
      </div>

      <!-- 协议勾选 -->
      <div class="agree-list">
        <div class="agree-row" @click="agree1 = !agree1">
          <span :class="['checkbox', { checked: agree1 }]">
            <svg v-if="agree1" viewBox="0 0 24 24" class="check-icon"><path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          <span class="agree-text">阅读并同意<a class="link" @click.stop="showDoc('电子社保卡用户协议')">《电子社保卡用户协议》</a>、<a class="link" @click.stop="showDoc('电子社保卡隐私政策')">《电子社保卡隐私政策》</a></span>
        </div>
        <div class="agree-row" @click="agree2 = !agree2">
          <span :class="['checkbox', { checked: agree2 }]">
            <svg v-if="agree2" viewBox="0 0 24 24" class="check-icon"><path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          <span class="agree-text">阅读并同意<a class="link" @click.stop="showDoc('就业在线用户协议')">《就业在线用户协议》</a>、<a class="link" @click.stop="showDoc('就业在线隐私政策')">《就业在线隐私政策》</a></span>
        </div>
      </div>

      <!-- 领取按钮 -->
      <div class="receive-btn" @click="handleReceive">领取电子社保卡</div>

      <!-- 备注说明 -->
      <div class="remark">
        <div class="remark-title">备注说明</div>
        <div class="remark-sub">1. 社会保障号码：</div>
        <div class="remark-line">· 持有居民身份证的中国公民，社会保障号码采用公民身份号码。</div>
        <div class="remark-line">· 没有居民身份证的港澳台人员、华侨，以及外国人，社会保障号码按照全国统一规则编制。</div>
        <div class="remark-sub">2. 就业在线：</div>
        <div class="remark-line">· 是由人力资源和社会保障部指导和组织建设的国家级招聘求职服务平台，为求职者提供一站式、全流程求职服务。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ECard',
  data() {
    return {
      agree1: false,
      agree2: false
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    showDoc(name) {
      this.$alert(name + '内容暂未提供')
    },
    handleReceive() {
      if (!this.agree1 || !this.agree2) {
        this.$alert('请先阅读并同意相关协议')
        return
      }
      this.$alert('电子社保卡领取成功')
    }
  }
}
</script>

<style scoped>
.ecard-page {
  min-height: 100%;
  background: #fff;
}
/* 青蓝标题栏（设计稿取色） */
.top-bar {
  position: relative;
  height: calc(170 * var(--w));
  background: #87C4CB;
  border-bottom: calc(2 * var(--w)) solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.close-btn {
  position: absolute;
  left: calc(48 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.close-icon {
  width: calc(46 * var(--w));
  height: calc(46 * var(--w));
}
.top-title {
  font-size: calc(48 * var(--w));
  color: #fff;
}

/* 蓝天白云成品图（含红色徽章），不再自定义背景色 */
.sky {
  flex-shrink: 0;
  line-height: 0;
}
.sky-img {
  display: block;
  width: 100%;
  height: auto;
}

/* 信息区（间距按设计稿量取） */
.info-area {
  background: #fff;
  padding: calc(44 * var(--w)) calc(50 * var(--w)) calc(60 * var(--w));
}
.field-label {
  font-size: calc(32 * var(--w));
  line-height: 1.3;
  color: #969696;
}
.field-value {
  margin-top: calc(24 * var(--w));
  font-size: calc(44 * var(--w));
  font-weight: normal;
  color: #363636;
  line-height: 1.2;
}
.field-gap {
  margin-top: calc(66 * var(--w));
}

/* 协议 */
.agree-list {
  margin-top: calc(94 * var(--w));
}
.agree-row {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.agree-row + .agree-row {
  margin-top: calc(63 * var(--w));
}
.checkbox {
  flex-shrink: 0;
  width: calc(42 * var(--w));
  height: calc(42 * var(--w));
  margin-top: calc(6 * var(--w));
  margin-right: calc(20 * var(--w));
  border: calc(2 * var(--w)) solid #C3C8CF;
  border-radius: calc(6 * var(--w));
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checkbox.checked {
  border-color: #2E8CF6;
  background: #2E8CF6;
}
.check-icon {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
}
.agree-text {
  flex: 1;
  font-size: calc(36 * var(--w));
  color: #999;
  line-height: 1.45;
}
.link {
  color: #198CE9;
  cursor: pointer;
}

/* 领取按钮（设计稿取色/量距） */
.receive-btn {
  margin-top: calc(84 * var(--w));
  height: calc(135 * var(--w));
  border-radius: calc(16 * var(--w));
  background: #1D87DE;
  color: #fff;
  font-size: calc(48 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.receive-btn:active {
  background: #1671BD;
}

/* 备注说明：设计稿全部为灰色常规字重，字号分两级 */
.remark {
  margin-top: calc(78 * var(--w));
}
.remark-title {
  font-size: calc(36 * var(--w));
  color: #878787;
  font-weight: normal;
  line-height: 1.3;
}
.remark-sub {
  margin-top: calc(50 * var(--w));
  font-size: calc(32 * var(--w));
  color: #878787;
  line-height: 1.4;
}
.remark-line {
  margin-top: calc(40 * var(--w));
  font-size: calc(34 * var(--w));
  color: #878787;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/ECard.vue